import { render, staticRenderFns } from "./Organization.vue?vue&type=template&id=4a1b1fe8&scoped=true"
import script from "./Organization.vue?vue&type=script&lang=js"
export * from "./Organization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1b1fe8",
  null
  
)

export default component.exports